import { MutationTree } from 'vuex'
import { Reports } from './types'

export const mutations: MutationTree<Reports> = {

    setReport(state, dataReport) {
        state.reports.push(dataReport)
    },
    setFilterReportsByString(state, { filterReports }) {
        state.filterReports = filterReports
    },
    resetFilterReportsState(state) {
        state.filterReports = state.reports
    },
    setCurrentReport(state, dataReport) {
        state.currentReport = dataReport
    },
    toogleGraphView(state) {
        state.graphView = !state.graphView
      },
    enableGraphView(state) {
        state.graphView = true
      },
    disableGraphView(state) {
        state.graphView = false
    },
    setOndemand(state, value) {
        state.ondemand = value
    },
    cleanReportsState(state) {
        state.reports.splice(0)
    }
}